export default __webpack_public_path__ + "static/homepage-057bef710c2fb3e462caafc35f358e5a.webm";